import React from "../../__compat__/react/main.entry.mjs.mjs";
import { StyledTableRow } from "./Table.styles.mjs.mjs";
import { TableContext } from "./Table.context.mjs.mjs";
export const TableRow = React.forwardRef((props, ref) => {
    const tableContext = React.useContext(TableContext);
    return (React.createElement(StyledTableRow, { ...props, ref: ref, role: "row", displayMode: tableContext.displayMode }, props.children));
});
TableRow.displayName = 'TableRow';
//# sourceMappingURL=TableRow.mjs.mjs.map